import { editorState } from "./types";

export const initialState: editorState = {
  contents: []
}